import { Star } from 'lucide-react';
import { testimonials } from '../../data/homepageData';

export function Testimonials() {
  return (
    <section id="reviews" className="section testimonials-section">
      <div className="testimonial-grid">
        {testimonials.map((item) => (
          <article className="testimonial-card" key={item.name}>
            <div className="stars" aria-label="5 hvězdiček">
              {Array.from({ length: 5 }).map((_, i) => <Star key={i} size={15} fill="currentColor" />)}
            </div>
            <p>„{item.text}“</p>
            <strong>{item.name}</strong>
            <small>{item.city}</small>
          </article>
        ))}
        <article className="rating-card">
          <strong>4,9 / 5</strong>
          <span>z 4200+ hodnocení</span>
          <small>Heureka</small>
        </article>
      </div>
    </section>
  );
}
